const getErrorMessage = (fieldErrors) => {
  if (!fieldErrors || Object.keys(fieldErrors).length === 0) {
    return null;
  }

  return Object.values(fieldErrors)[0];
};

export default getErrorMessage;
